<!-- Form -->
@if (authorNoteForm) {
  <medsurf-design-form-control-form
    [formGroup]="authorNoteForm"
    class="w-full"
    className="h-full"
    (onSubmit)="onSubmit()">
    <!-- Editor -->
    <medsurf-editor [formField]="false"
      [control]="authorNoteForm.controls.authorNote"
      placeholder="global.comment"
      class="h-full"
      [fullHeight]="true"
      [autogrow]="false"
      [toolbarExcludes]="['mediaimage', 'mediapdf', 'mediaaudio', 'mediavideo', 'marker']"
    (valueChange)="onSubmit()"></medsurf-editor>
  </medsurf-design-form-control-form>
}
